import { setupForDark } from '@theme';
import classNames from 'classnames';

export default function SubtractBadgeIcon({
  text,
  className = '',
  onClick = (event) => {}
}: {
  text: string;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <div
      className={classNames(
        'flex items-center justify-center gap-xxs px-xxs py-[1px] rounded-xxs border-[2px] border-solid',
        setupForDark('border-icon-primary bg-icon-primary'),
        className
      )}
      onClick={onClick}
    >
      <span className='text-quaternary text-p6-m font-medium leading-5'>{text}</span>
    </div>
  );
}
